<app-room-item-view [room]="room"></app-room-item-view>
<button style="width: 100%" mat-raised-button color="primary" (click)="joinClicked()">{{'join'|translate}}</button>
